import z from "zod";
import { BaseSchema, ImageSchema, PaginationSchema } from "../common";
import { DistrictSectionSchemas } from "./district-sections";

const DistrictSchema = z.object({
  ...BaseSchema.shape,
  slug: z.string().optional(),
  code: z.string().optional(),
  cityId: z.uuidv7(),
  translations: DistrictSectionSchemas.translation,
  image: z.string().optional(),
});

export const DistrictSchemas = {
  populated: BaseSchema.extend({
    slug: z.string().min(1, "slug is required!"),
    cityId: z.uuidv7(),
    cityName: z.string(),
    translations: DistrictSectionSchemas.translation,
    image: z.string().optional(),
  }),

  list: PaginationSchema.extend({
    slug: z.string().optional(),
    all: z.boolean().optional(),
    sort: z.string().optional(),
  }),

  find: z.object({ id: z.uuidv7() }),

  findBySlug: z.object({ slug: z.string() }),

  findLegacyRedirect: z.object({ slug: z.string() }),

  delete: z.object({ id: z.uuidv7() }),

  getRedirect: z.object({ code: z.number() }),

  create: z.object({
    slug: z.string().optional(),
    image: ImageSchema,
    altText: z.string().nullish(),
    cityId: z.uuidv7(),
    translations: DistrictSectionSchemas.translation,
    sections: z.array(DistrictSectionSchemas.create),
  }),

  update: z.object({
    id: z.uuidv7(),
    slug: z.string().optional(),
    image: ImageSchema,
    altText: z.string().nullish(),
    cityId: z.uuidv7(),
    translations: DistrictSectionSchemas.translation,
    sections: DistrictSectionSchemas.update.array(),
  }),
};

export type PopulatedDistrict = z.infer<typeof DistrictSchemas.populated>;
export type District = z.infer<typeof DistrictSchema>;
export type DistrictSection = z.infer<typeof DistrictSectionSchemas.item>;
export type UpdateDistrict = z.infer<typeof DistrictSchemas.update>;
export type CreateDistrict = z.infer<typeof DistrictSchemas.create>;
